import { css } from '@emotion/react'
import { Capsule, SCapsuleWrapper } from 'components/capsule/Capsule'
import { BasicTextImageSection } from 'components/content/basicTextImageSection/BasicTextImageSection'
import { Icon } from 'components/icon'
import { Title_h4_default } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { BREAKPOINTS } from 'utils/styled'

export const FutureMessageLPWhen = () => {
  const { t } = useTranslation('future_message')
  const images = useContentfulImages()

  return (
    <BasicTextImageSection
      title={t('future_message.when_to_send_section.title')}
      titleVariant={Title_h4_default}
      css={css`
        & > div {
          grid-gap: 10rem;
          grid-template-columns: 1.5fr 1fr;

          @media ${BREAKPOINTS.LG.max} {
            grid-gap: 5rem;
          }

          @media ${BREAKPOINTS.MD.max} {
            grid-template-columns: 1fr;
            grid-gap: 0.5rem;
          }
        }
      `}
      desc={
        <SCapsuleWrapper css={{ paddingBottom: '2rem' }}>
          <Capsule
            title={
              <>
                <Icon name="Hourglass" css={{ marginRight: '0.5rem' }} />
                {t('future_message.when_to_send_section.box_1.title')}
              </>
            }
            desc={t('future_message.when_to_send_section.box_1.description')}
          />

          <Capsule
            title={
              <>
                <Icon name="Cake" css={{ marginRight: '0.5rem' }} />
                {t('future_message.when_to_send_section.box_2.title')}
              </>
            }
            desc={t('future_message.when_to_send_section.box_2.description')}
          />

          <Capsule
            title={
              <>
                <Icon name="FuneralDirective" css={{ marginRight: '0.5rem' }} />{' '}
                {t('future_message.when_to_send_section.box_3.title')}
              </>
            }
            desc={t('future_message.when_to_send_section.box_3.description')}
          />

          <Capsule
            title={
              <>
                <Icon name="LightBulb" css={{ marginRight: '0.5rem' }} />{' '}
                {t('future_message.when_to_send_section.box_4.title')}
              </>
            }
            desc={t('future_message.when_to_send_section.box_4.description')}
          />
        </SCapsuleWrapper>
      }
      descNoMaxWidth
      textWrapperCSS={css`
        @media ${BREAKPOINTS.MD.max} {
          margin: 0;
        }
      `}
      imageWrapperCSS={{ justifyContent: 'flex-start' }}
      image={images.future_message_when_to_send}
    />
  )
}
